import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';

export const getHSCodesQuery = gql`
  query hsCodes($breweryId: Int!) {
    hsCodes(breweryId: $breweryId) {
      id
      name
      description
    }
  }
`;

const HSCodeOptions = ({ brewery }) => (
  <Query query={getHSCodesQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <option>...</option>;
      }

      if (error) {
        return <option>Sorry, there was an error getting the HS Codes</option>;
      }

      return (
        <Fragment>
          <option value="">Select a code</option>
          {data.hsCodes.map(code => (
            <option key={code.id} value={code.id}>
              {code.name}
              {code.description && code.description.length && ` (${code.description})`}
            </option>
          ))}
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(HSCodeOptions);



// WEBPACK FOOTER //
// ./src/containers/hsCodeOptions/hsCodeOptions.jsx